import React, { useState } from "react";
import "./BCard.css";
import TwitterLogo from "./images/twitter-logo.png";
import FacebookLogo from "./images/facebook-logo.png";
import InstagramLogo from "./images/instagram-logo.png";
import YoutubeLogo from "./images/youtube-logo.png";

const platformIcons = {
  twitter: TwitterLogo,
  facebook: FacebookLogo,
  instagram: InstagramLogo,
  youtube: YoutubeLogo,
};

const BrandCard = ({ brand }) => {
  const {
    id,
    name,
    friendlyName,
    insertedDate,
    sector,
    subsector,
    metrics,
    channels,
  } = brand;
  const [isFlipped, setIsFlipped] = useState(false);

  const toggleFlip = () => {
    setIsFlipped(!isFlipped);
  };

  return (
    <div
      className={`brandcard ${isFlipped ? "flipped" : ""}`}
      onClick={toggleFlip}
    >
      {/* Front Side */}
      <div className="brandcard-front">
        <div className="brandcard-header">
          <div className="brandcard-id">BrandId : {id}</div>
          <div className="brandcard-info">
            <h3>{friendlyName}</h3>
          </div>
        </div>

        <div className="brandcard-metrics">
          <div className="metric-main">
            <span>This Week</span>
            <div className="mention-block">
              <span className="mention-count">{metrics.totalMentions}</span>
              {typeof metrics.trendPercentage === "number" && (
                <span
                  className={`trend ${
                    metrics.trendPercentage >= 0 ? "up" : "down"
                  }`}
                >
                  {metrics.trendPercentage >= 0 ? "▲" : "▼"}{" "}
                  {Math.abs(metrics.trendPercentage).toFixed(1)}%
                </span>
              )}
            </div>
          </div>
          <div className="metric-row">
            <div className="metric-box">
              <strong>{metrics.brandPosts > 0 ? metrics.brandPosts : 0}</strong>
              <span>Brand Posts</span>
            </div>
            <div className="metric-box">
              <strong>
                {metrics.brandReplies > 0 ? metrics.brandReplies : 0}
              </strong>
              <span>Brand Replies</span>
            </div>
            <div className="metric-box">
              <strong>
                {metrics.userComments > 0 ? metrics.userComments : 0}
              </strong>
              <span>User Comments</span>
            </div>
          </div>
        </div>

        <div className="socials">
          <span>Social Channels</span>
          <div className="icon-row">
            {Object.entries(channels).map(([platform, links]) => {
              if (!links || links.length === 0) return null;
              const logo = platformIcons[platform];
              return (
                <div key={platform} className="icon-tooltip">
                  <img src={logo} alt={platform} width={20} height={20} />
                  <span className="tooltip">
                    {links.map((url, idx) => (
                      <div key={idx}>{url}</div>
                    ))}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="brandcard-footer">
          <div className="date">📅 {insertedDate}</div>
          <div className="sector">
            {sector} - {subsector}
          </div>
        </div>
      </div>

      {/* Back Side */}
      <div className="brandcard-back">
        <div className="brandcard-header">
          <div className="brandcard-id">BrandId : {id}</div>
          <div className="brandcard-info">
            <h3>{friendlyName}</h3>
          </div>
        </div>

        <div className="brandcard-metrics">
          <div className="metric-main">
            <span>From Beginning</span>
            <div className="mention-block">
              <span className="mention-count">
                {metrics.totalMentionsFromBeginning > 0
                  ? metrics.totalMentionsFromBeginning
                  : 0}
              </span>
            </div>
          </div>
          <div className="metric-row">
            <div className="metric-box">
              <strong>
                {metrics.brandPostsFromBeginning > 0
                  ? metrics.brandPostsFromBeginning
                  : 0}
              </strong>
              <span>Brand Posts</span>
            </div>
            <div className="metric-box">
              <strong>
                {metrics.brandCommentsFromBeginning > 0
                  ? metrics.brandCommentsFromBeginning
                  : 0}
              </strong>
              <span>Brand Comments</span>
            </div>
            <div className="metric-box">
              <strong>
                {metrics.userCommentsFromBeginning > 0
                  ? metrics.userCommentsFromBeginning
                  : 0}
              </strong>
              <span>User Comments</span>
            </div>
          </div>
        </div>

        <div className="socials">
          <span>Social Channels</span>
          <div className="icon-row">
            {Object.entries(channels).map(([platform, links]) => {
              const logo = platformIcons[platform];
              return (
                <div key={platform} className="icon-tooltip">
                  <img src={logo} alt={platform} width={20} height={20} />
                  <span className="tooltip">
                    {links.map((url, idx) => (
                      <div key={idx}>{url}</div>
                    ))}
                  </span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="brandcard-footer">
          <div className="date">📅 {insertedDate}</div>
          <div className="sector">
            {sector} - {subsector}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandCard;
